import { API_V1 } from './APIs/APIv1';
import { ApiResponse } from '../features/lead-list-research/webmetics/webmetics.types';
import Logger from 'logger';
import _ from 'lodash';

export interface WorktimePayload {
  workDays?: string[]; // 'monday'...'sunday'
  workHours?: number[]; // [start, end]
  timeZone?: string;
}

export interface LimitsPayload {
  messageDailyLimit?: number | null;
  // old plural names are still accepted by the backend and map automatically
  connectionsLimit?: number | null;
  emailsLimit?: number | null;
  coldCallsLimit?: number | null;
  // canonical names (preferred)
  connectionDailyLimit?: number | null;
  emailDailyLimit?: number | null;
  coldCallDailyLimit?: number | null;
  inmailDailyLimit?: number | null;
  visitDailyLimit?: number | null;
  cooldownAfterMessages?: number | null;
  cooldownAfterVisits?: number | null;
}

export const patchLinkedinAccountWorktime = async (accountId: string, payload: WorktimePayload): Promise<ApiResponse<unknown>> => {
  return API_V1.patch(`/linkedin-accounts/${accountId}/worktime`, payload);
};

export const updateLinkedinAccountWorkTime = async (accountId: string, payload: WorktimePayload) => {
  try {
    const response = await API_V1.patch(`/linkedin-accounts/${accountId}/worktime`, payload);

    return response.data;
  } catch (e) {
    Logger.trace('Error while updating the linkedin account %s worktime!', accountId);
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const patchLinkedinAccountLimits = async (accountId: string, payload: LimitsPayload): Promise<ApiResponse<unknown>> => {
  return API_V1.patch(`/linkedin-accounts/${accountId}/limits`, payload);
};

export const updateLinkedinAccountLimits = async (accountId: string, payload: LimitsPayload) => {
  try {
    const response = await API_V1.patch(`/linkedin-accounts/${accountId}/limits`, payload);

    return response.data;
  } catch (e) {
    Logger.trace('Error while updating the linkedin account %s limits!', accountId);
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
